import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteSupportCategory() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function deleteCategory(categoryId) {
    return privateFetch.delete(`/v1/admin/support/category/${categoryId}`);
  }

  return useMutation(deleteCategory, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('support-category');
    },
  });
}

export default useDeleteSupportCategory;
